module.exports = __webpack_public_path__ + "static/media/tick.2c61c083.svg";